/**
 * This causes TypeScript compilation to error. Useful for protecting a default case from being used in a switch
 * @param x
 */
export const UnreachableError = (x: never): never => {
    throw new Error(`Should not reach this statement: ${x}`);
};
